// Thin axios wrapper for LE 11. All backend calls go through `/api`.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
});

export const healthCheck = () => api.get("/health").then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
